import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import {
    findCalendarGroup,
    CalendarGroup,
    getCalendarGroups,
    updateStoreCalendarGroups,
} from 'owa-calendar-surface-calendars-store';

export function instantReorderCalendarGroups(
    draggedGroupId: string,
    prevGroupId: string,
    nextGroupId: string,
    userIdentity: string
) {
    const draggedGroup = findCalendarGroup(draggedGroupId, userIdentity);
    const calendarGroups: CalendarGroup[] = getCalendarGroups().slice();
    const insertAfter = prevGroupId != undefined ? true : false;
    const calendarGroupId = prevGroupId != undefined ? prevGroupId : nextGroupId;

    // remove the group from the old position
    const findDraggedGroupResult = findInArray(
        calendarGroups,
        group =>
            group.groupId == draggedGroupId && group.id.mailboxInfo.userIdentity == userIdentity
    );
    findDraggedGroupResult && calendarGroups.splice(findDraggedGroupResult.index, 1);

    // Added the group in the new position
    const findGroupResult = findInArray(
        calendarGroups,
        group =>
            group.groupId == calendarGroupId && group.id.mailboxInfo.userIdentity == userIdentity
    );

    if (findGroupResult) {
        const index = insertAfter ? findGroupResult.index + 1 : findGroupResult.index;
        calendarGroups.splice(index, 0, draggedGroup);
    }

    updateStoreCalendarGroups(calendarGroups);
}
